<template>
  <div class="cart-product bg-white bd-radius-5 p-0">
    <b-tabs card class="tab-courier">
      <b-tab title active class="py-3">
          <template v-slot:title>
              <div class="my-2 h3 px-1">
                  บริการขนส่ง
              </div>
          </template>
          <DropParcelLineBooking 
            v-if="tabCourier.step === getStepPage.STEP_LINEBOOKING" 
            :tabCourier="tabCourier"
            :listSize="listSize"
            :showCart="showCart"
            :cart="cart"
            :count="count"
            :sender="sender"
            :couriers="couriers"
            :insurance="insurance"
            :dropoffLine="dropoffLine"
            @addDraftStorage="addDraftStorage"
            @checkDisableCardCourier="checkDisableCardCourier"
            @settingCartSlide="$emit('openCartComponent', $event)"
          />
          <TabCategoryCourier
              v-if="tabCourier.step === getStepPage.STEP_COURIER" 
              @checkPriceFrom="checkPriceFrom"
              :showCart="showCart"
              :cart="cart"
              :draftStorage="draft_storage"
              :idOrder="idorder"
              :shopId="shop_id"
              :posPage="posPage"
              :tabCourier="tabCourier"
              :couriers="couriers"
              :searchCourier="searchCourier"
              :permission="permission"
              :dropoffVRich="dropoffVRich"
              :dropoffPanPan="dropoffPanPan"
              :dropoffEasyShip="dropoffEasyShip"
              :dropoffQuick="dropoffQuick"
              :cod="cod"
              :lockCardCourier="lockCardCourier"
              :courierDropoffVRich="courierDropoffVRich"
              :courierDropoffEasyShip="courierDropoffEasyShip"
              :courierDropoffQuick="courierDropoffQuick"
              :DROPOFF_SP="DROPOFF_SP"
              :LAZADA_DROPOFF="LAZADA_DROPOFF"
              :KERRY_DROPOFF="KERRY_DROPOFF"
              :ORANGE_DROPOFF="ORANGE_DROPOFF"
              :FLASH_DROPOFF="FLASH_DROPOFF"
              :showCourier="showCourier"
              @courierModalTime="courierModalTime"
              @openModal="openModal"
              @reverseCourier="beforeGetShop"
              @openModalDraft="openModalFromKey"
          />
      </b-tab>
      <b-tab @click="hasRefMemId" class="py-3" v-if="($THEME.serviceName.inter || (refMemberId && permission.interParcelService)) || ($THEME.serviceName.inter && shopInBKK())">
        <template v-slot:title>
          <div class="my-2 h3 px-1">
              บริการขนส่งต่างประเทศ
          </div>
        </template>
        <div v-if="!permission.interParcelService && !sentLead" class="text-center">
          <!-- <h1>🛫 ส่งของจากไทยไปทั่วโลก</h1>
          -->
          <!-- <img width="500" src="https://scontent.fbkk7-3.fna.fbcdn.net/v/t39.30808-6/363295335_263675166409024_2330643166098555947_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeGpigMcDmQGJKxMl_4dTRyzusqVSYxkkE-6ypVJjGSQT-ZkN4AeT8fESr9QYSpYkNw&_nc_ohc=d3DKgZKcbYgAX8BlLtQ&_nc_ht=scontent.fbkk7-3.fna&oh=00_AfAnqXvHQ7Il5RH3hyNBzJ4tPXk7Wsx0cl6yHT85oQ5WWw&oe=64E06737" /> -->
          <div class="pt-2">
            <button class="btn btn-primary py-2 px-3" @click="sentSalesOpenINTER">
               ลงทะเบียนเปิดใช้งานขนส่งต่างประเทศ
            </button>
          </div>
        </div>
        <div class="text-center text-success pt-5"  v-if="!permission.interParcelService && sentLead">
          <div><i class="fa fa-check"></i> ลงทะเบียนเรียบร้อย รอการติดต่อกลับจากฝ่ายขาย</div>
        </div>
        <div class="text-center text-success" :class="{'pt-4': !sentLead}" v-if="!permission.interParcelService">
          <div>
            สอบถามข้อมูลเพิ่มเติมได้ที่ LINE Official: <a href="https://line.me/R/ti/p/@shippopinter" target="_blank">@shippopinter</a>
            <br/><br/>
            <img src="img/line_oa_inter.png" width="188"/>
          </div>
        </div>
        <div v-if="permission.interParcelService" class="row pr-3 py-2">
          <div class="col-6 col-lg-6 col-xl-8">
              <h4 class="cursor-pointer d-flex align-items-center text-color-draft" v-if="!checkThemeQuick()" @click="emitModal('draftStorage')">
                  <span>
                      <img :src="iconDraft.url" alt="">
                  </span>
                  <span class="ml-1">
                      {{ draftLength ? `ฉบับร่าง (${countDraft()})` : "ฉบับร่าง (0)" }}
                  </span>
              </h4>
          </div>
          <div class="col-6 col-lg-6 col-xl-4 text-right">
              <b-button 
                  id="checkPrice" 
                  :class="showCart !== 'non-slide' ? 'mr-4' : ''" 
                  variant="primary" 
                  size="sm" 
                  :disabled="(idorder) ? true : false" 
                  @click="changeStepPosPage(getStepPage.STEP_PAGE_CHECKPRICE)" 
              >
                  <i class="fas fa-database"></i>
                  เปรียบเทียบราคา
              </b-button>
          </div>
        </div>
        <div class="row pr-3">
          <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.interParcelService">
            <CardPos
                :courier="{
                    title:'Road To LAOS', 
                    name:'LAOBooking', 
                    icon:'LAO.png',
                }"
                :starShow="false"
                :class="{disabled:idorder , lockcourier:lockCardCourier.dropoffLAO}"
                @click.native="openModal('LAO_BOOK' , false)" 
            />
          </div>
          <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-if="permission.interParcelService">
              <CardPos
                  :courier="{
                      title:'SHIPPOP International', 
                      name:'SHIPPOP International', 
                      icon:'INTER.png',
                  }"
                  :starShow="false"
                  :class="{disabled:idorder , lockcourier:lockCardCourier.dropoffINTER}"
                  @click.native="openModal('INTER_BOOK' , false)" 
              />
          </div>
        </div>
      </b-tab>
      <b-tab class="py-3">
        <template v-slot:title>
          <div class="my-2 h3 px-1">สินค้า</div>
        </template>
        <TabCategoryItem 
            :showCart="showCart"
            :cart="cart"
            ref="categoryItem" 
            :idOrder="idorder" 
            :busy.sync="busy" 
            :addToCart="addToCart"     
             />
      </b-tab>
      <b-tab class="py-3">
        <template v-slot:title>
          <div class="my-2 h3 px-1">บริการเสริม</div>
        </template>
        <TabCategoryService 
          :showCart="showCart"
          :cart="cart"
          :idOrder="idorder" 
          :tmpService="tmpService" 
          :addService="addServiceNew"
          :insuranceService="insuranceService" 
          :zendai="zendai" 
          :permission="permission"
          @openModal="openModal($event, $event)" @openModalService="openModalService()"
          />
      </b-tab>
    </b-tabs>
    <span class="tags-top-right">
      <b-badge 
          v-if="sender.name != '' && sender.identity == false"
          variant="success" 
      >
          ยืนยันตัวตนแล้ว
      </b-badge>
      <b-badge 
          v-else-if="sender.identity" 
          variant="success" 
      >
          ยืนยัน COD แล้ว
      </b-badge>
      <b-badge v-else variant="warning">ไม่ได้ยืนยันตัวตน</b-badge>
    </span>
  </div>
</template>

<script>
import CardPos from "@/components/CardPos";
// import TabCategoryCourier from '@/components/custom/pos/TabCategoryCourier'
import TabCategoryCourier from '@/components/custom/pos/NewTabCategoryCourier'
import TabCategoryService from '@/components/custom/pos/TabCategoryService'
import TabCategoryItem from '@/components/custom/pos/TabCategoryItem'
import { setCookie, getCookie } from "@/helpers/util"
import { 
    getStepPage
} from "@/plugins/posHelper.js";
import DropParcelLineBooking from '@/components/custom/pos/DropParcelLineBooking'

export default {
  props:{
    showSuccessModal: Function,
    showCart: String,
    cart: Array,
    shopDetail: Object,
    refMemberId: String,
    draft_storage: Array,
    idorder: String,
    shop_id: [String, Number],
    sender: Object,
    posPage: Object,
    couriers: Array,
    insurance: Object,
    searchCourier: String,
    permission: Object,
    dropoffVRich: Object,
    dropoffEasyShip: Object,
    dropoffPanPan: Object,
    dropoffQuick: Object,
    cod: [String, Number],
    lockCardCourier: Object,
    courierDropoffVRich: Object,
    courierDropoffEasyShip: Object,
    courierDropoffQuick: Object,
    showCourier: [Function, Boolean],
    listSize: Object,
    ORANGE_DROPOFF: String,
    DROPOFF_SP: String,
    LAZADA_DROPOFF: String,
    KERRY_DROPOFF: String,
    FLASH_DROPOFF: String,
    busy: Boolean,
    addToCart: [Function],
    tmpService: Object,
    addServiceNew: Function,
    insuranceService: Object,
    zendai: Object,
    courierModalTime: Function,
    openModal: Function,
    beforeGetShop: Function,
    openModalFromKey: Function,
    openModalService: Function,
    addDraftStorage: Function,
    checkDisableCardCourier: Function,
    count: Number,
    dropoffLine: Object
  },
  components: {
    CardPos,
    TabCategoryCourier,
    TabCategoryService,
    TabCategoryItem,
    DropParcelLineBooking
  },
  data:() => ({
    getStepPage,
    tabCourier:{
      step: getStepPage.STEP_COURIER,
      subStep: getStepPage.SUB_STEP_CREATEBOOKING
    },
    iconDraft: {
        url: require("../../../assets/icon/Drafts.svg")
    },
    sentLead: false
  }),
  mounted() {
    this.checkSentLeadInter();
  },
  methods:{
    shopInBKK() {
      console.log('shop bkk', this.shopDetail.postcode,this.shopDetail.postcode.substr(0,2))
      if (this.shopDetail && this.shopDetail.postcode) {
        return ['10', '11', '12'].includes(this.shopDetail.postcode.substr(0,2))
      }
      console.log('shop in bkk', this.shopDetail.postcode)
      return false;
    },
    checkPriceFrom(key) {
      this.$emit('checkPriceFrom', key)
    },
    changeStepPosPage( step ){
      if(getStepPage.STEP_PAGE_CHECKPRICE === step) {
        this.$emit('checkPriceFrom', 'INTER')
      }
      this.posPage.step = step
    },
    emitModal(key) {
      return this.$emit('openModalDraft', key)  
    },
    checkThemeQuick(){
      return this.$THEME.name == 'quickexpress';
    },
    checkSentLeadInter() {
      // check register lead
      const shopCode = this.$USER_LOGIN.get().details.shop_code

      const keyInter = shopCode + '-INTER-LEAD';
      const cookieINTER = getCookie(keyInter)

      const oldKeyInter1 = shopCode + '-INTER';
      const getOldCookieInter = getCookie(oldKeyInter1)
      console.log('new lead ->', oldKeyInter1, getOldCookieInter)
      if(cookieINTER || getOldCookieInter) {
        console.log('new inter', cookieINTER,'o inter', getOldCookieInter)
        this.sentLead = true;
        if (getOldCookieInter) {
          let a = setInterval(() => {
            console.log('retry lead')
            if (this.shopDetail.tel) {
              console.log('found tel')
              this.sentSalesOpenINTER();
              clearInterval(a);
            }
          }, 5000);
          
          setCookie(oldKeyInter1, false, -1)          
        }
      }
    },
    sentSalesOpenINTER() {
      const shopCode = this.$USER_LOGIN.get().details.shop_code
      const detailShop = this.$USER_LOGIN.get()

      const keyInter = shopCode + '-INTER-LEAD'
      const cookieINTER = getCookie(keyInter)
      if(cookieINTER) {
        this.sentLead = true;
        return true
      }else if (this.shopDetail.tel) {
        const formData = new URLSearchParams();
        formData.append('name', detailShop['details']['shop_name'] + ` (${detailShop['details']['shop_code']})`);
        formData.append('name_contact', this.shopDetail.owner_name);
        formData.append('phone', this.shopDetail.tel);
        formData.append('email_address', detailShop['details']['email']);
        formData.append('courier', 'INTER');
        formData.append('shop_id', shopCode);
        this.$http.post('https://www1.shippop.com/embed/register/inter/popshop/', formData)
          .then(() => {
        })
        // this.showSuccessModal('คุณได้ทำการส่งคำร้องเรียบร้อยแล้ว')
        setCookie(keyInter, true, 30)
        this.sentLead = true;
      } else {
        console.log('เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่')
      }
    },
    hasRefMemId() {
      return this.$emit('hasErrorRefMemId', true)
    },
    changeStepTabCourier( step ){
      this.tabCourier.step = step
    },
    countDraft() {
      return this.draft_storage?Object.keys(this.draft_storage).length:0
    },
    draftLength() {
      return this.draft_storage?Object.keys(this.draft_storage).length > 0:false;
    },
  }
}
</script>

<style>

</style>